import React, {useState,useEffect} from "react";
import Suppliercharts from "./Suppliercharts";
import Suppliermap from "./Suppliermap";
import { getAuthorization } from "../../../../axios/AxiosAut";

export default function Suppliercards() {

  const [Rejectedorders, setRejectedorders] = useState([]);
  const getData = () => {
    getAuthorization()
      .get(`dashboard/suppliers/get_rejected_orders/`)
      .then((res) => {
        console.log(" data", res.data.rejected_orders
        );
        setRejectedorders(res.data.rejected_orders
          );
      })
      .catch((err) => {
        console.log("err", err);
      });
  };
  useEffect(() => {
    getData();
    console.log("Rejectedorders.....", Rejectedorders);
  }, []);

  const state = {
    stroke: {
      lineCap: "round",
    },
    options: {
      dataLabels: {
        enabled: false,
      },
      legend: {
        fontSize: "18px",
        fontWeight: "700",
        fontFamily: "Poppins",
        position: "right",
        horizontalAlign: "center",

        // labels: {
        //   show: true,
        //   name: "Total Issus",
        //   value: 263,
        // },
      },

      title: {
        text: "25",
        align: "center",
        margin: 10,
        offsetX: -55,
        offsetY: 125,
        floating: false,
        style: {
          fontSize: "28px",
          fontWeight: "bold",
          color: "#000",
        },
      },
      subtitle: {
        text: "Issues",
        align: "center",
        margin: 10,
        offsetX: -55,
        offsetY: 155,
        floating: false,
        style: {
          fontSize: "20px",
          fontWeight: "300",
          color: "#000",
        },
      },
      // subtitle: {
      //   text: ,
      //   align: "center",
      //   margin: 10,
      //   offsetX: 0,
      //   offsetY: 105,
      //   floating: false,
      //   style: {
      //     fontSize: "14px",
      //     fontWeight: "bold",
      //     color: "#000",
      //   },
      // },
      labels: ["Faulty", "Damaged", "Incorrect"],
      colors: ["#FF0000", "#FFFF00", "#FC7A00"],

      plotOptions: {
        pie: {
          customScale: 1,
          donut: {
            size: "83%",
            // labels: {
            //   show: true,
            //   name: "Total Issus",
            //   value: 263,
            // },
          },
        },
      },
    },

    series: [45, 35, 25],
  };
  return (
    <div className="">
      <div class="flex w-3/4  flex-wrap justify-center mt-8 mb-8">
        <div className="w-full flex-1 shadow-md shadow-slate-400 bg-white sm:w-1/2 md:w-1/3 lg:w-1/5 xl:w-1/6 mb-4 mx-1 rounded-xl mr-6">
          <div className="text-center  mt-4">
            <div className="text-center">
              <button className=" text-center rounded-full w-12  bg-cyan-200 text-lg font-bold outline-1 mx-2">
                {" "}
                <svg
                  className="relative top-1 left-1.5"
                  width="48"
                  height="48"
                  viewBox="0 0 32 32"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M16.8684 17.263L17.222 16.9095L17.5755 17.263L17.222 17.6166L16.8684 17.263ZM13.0246 12.7121L17.222 16.9095L16.5149 17.6166L12.3175 13.4192L13.0246 12.7121ZM17.222 17.6166L13.0246 21.814L12.3175 21.1069L16.5149 16.9095L17.222 17.6166Z"
                    fill="#1F78B4"
                  />
                  <path
                    d="M13.7204 8.86841L17.9177 8.86841"
                    stroke="#1F78B4"
                    stroke-linecap="round"
                  />
                  <path
                    d="M16.8684 17.2631H8.47368C6.15553 17.2631 4.27631 15.3839 4.27631 13.0658V13.0658C4.27631 10.7476 6.15553 8.86841 8.47368 8.86841H9.52302"
                    stroke="#1F78B4"
                    stroke-linecap="round"
                  />
                </svg>
              </button>
            </div>
          </div>
          <h1 className="text-4xl text-center font-bold mt-4">{Rejectedorders}</h1>
          <h1 className="text-lg text-center text-gray-500 mt-2 font-bold ">
            Rejected Orders
          </h1>
          <p className="text-lime-400 text-center mb-1">
            <span>
              <span className="inline-block">
                <svg
                  width="14"
                  height="14"
                  viewBox="0 0 12 12"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M7 7L7.70711 6.29289L7 5.58579L6.29289 6.29289L7 7ZM11.2071 9.79289L7.70711 6.29289L6.29289 7.70711L9.79289 11.2071L11.2071 9.79289ZM6.29289 6.29289L2.79289 9.79289L4.20711 11.2071L7.70711 7.70711L6.29289 6.29289Z"
                    fill="#26F32E"
                  />
                  <path
                    d="M7 3.5L7.70711 2.79289L7 2.08579L6.29289 2.79289L7 3.5ZM11.2071 6.29289L7.70711 2.79289L6.29289 4.20711L9.79289 7.70711L11.2071 6.29289ZM6.29289 2.79289L2.79289 6.29289L4.20711 7.70711L7.70711 4.20711L6.29289 2.79289Z"
                    fill="#26F32E"
                  />
                </svg>
              </span>
            </span>
            <span className="ml-1 font-medium">45.38%</span>
          </p>
          <div className="text-center flex justify-center ml-auto mt-1 mb-4">
            <div className="">
              <button className="rounded-full w-8 text-blue-900 hover:bg-white hover:text-black active:text-white active:bg-blue-200 bg-cyan-200 text-lg font-bold outline-1 mx-2">
                {" "}
                Y
              </button>
            </div>
            <div className="">
              <button className="rounded-full w-8 text-blue-900 hover:bg-white hover:text-black active:text-white active:bg-blue-200 bg-cyan-200 text-lg font-bold outline-1 mx-2">
                {" "}
                M
              </button>
            </div>

            <div className="">
              <button className="rounded-full w-8 hover:bg-white hover:text-black active:text-white active:bg-blue-200 bg-blue-200 text-lg font-bold text-white outline-1 mx-2">
                {" "}
                W
              </button>
            </div>
          </div>
        </div>
        <div className="w-full flex-1 shadow-md shadow-slate-400 bg-white sm:w-1/2 md:w-1/3 lg:w-1/5 xl:w-1/6 mb-4 mx-1 rounded-xl mr-6">
          <div className="text-center  mt-4">
            <div className="text-center">
              <button className=" text-center rounded-full w-12  bg-cyan-200 text-lg font-bold outline-1 mx-2">
                {" "}
                <svg
                  className="relative top-1.5 left-1.5"
                  width="48"
                  height="48"
                  viewBox="0 0 32 32"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle
                    cx="12"
                    cy="12"
                    r="9"
                    fill="#FBFDFF"
                    fill-opacity="0.29"
                  />
                  <path
                    d="M9 10L12.2581 12.4436C12.6766 12.7574 13.2662 12.6957 13.6107 12.3021L20 5"
                    stroke="#1F78B4"
                    stroke-width="1.2"
                    stroke-linecap="round"
                  />
                  <path
                    d="M21 12C21 13.8805 20.411 15.7137 19.3156 17.2423C18.2203 18.7709 16.6736 19.9179 14.893 20.5224C13.1123 21.1268 11.187 21.1583 9.38744 20.6125C7.58792 20.0666 6.00459 18.9707 4.85982 17.4789C3.71505 15.987 3.06635 14.174 3.00482 12.2945C2.94329 10.415 3.47203 8.56344 4.51677 6.99987C5.56152 5.4363 7.06979 4.23925 8.82975 3.57685C10.5897 2.91444 12.513 2.81996 14.3294 3.30667"
                    stroke="#1F78B4"
                    stroke-width="1.2"
                    stroke-linecap="round"
                  />
                </svg>
              </button>
            </div>
          </div>
          <h1 className="text-4xl text-center font-bold mt-4">98%</h1>
          <h1 className="text-lg text-center text-gray-500 mt-2 font-bold ">
            Order Pass Rate
          </h1>
          <p className="text-lime-400 text-center mb-1">
            <span>
              <span className="inline-block">
                <svg
                  width="14"
                  height="14"
                  viewBox="0 0 12 12"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M7 7L7.70711 6.29289L7 5.58579L6.29289 6.29289L7 7ZM11.2071 9.79289L7.70711 6.29289L6.29289 7.70711L9.79289 11.2071L11.2071 9.79289ZM6.29289 6.29289L2.79289 9.79289L4.20711 11.2071L7.70711 7.70711L6.29289 6.29289Z"
                    fill="#26F32E"
                  />
                  <path
                    d="M7 3.5L7.70711 2.79289L7 2.08579L6.29289 2.79289L7 3.5ZM11.2071 6.29289L7.70711 2.79289L6.29289 4.20711L9.79289 7.70711L11.2071 6.29289ZM6.29289 2.79289L2.79289 6.29289L4.20711 7.70711L7.70711 4.20711L6.29289 2.79289Z"
                    fill="#26F32E"
                  />
                </svg>
              </span>
            </span>
            <span className="ml-1 font-medium">45.38%</span>
          </p>
          <div className="text-center flex justify-center ml-auto mt-1 mb-4">
            <div className="">
              <button className="rounded-full w-8 text-blue-900 hover:bg-white hover:text-black active:text-white active:bg-blue-200 bg-cyan-200 text-lg font-bold outline-1 mx-2">
                {" "}
                Y
              </button>
            </div>
            <div className="">
              <button className="rounded-full w-8 text-blue-900 hover:bg-white hover:text-black active:text-white active:bg-blue-200 bg-cyan-200 text-lg font-bold outline-1 mx-2">
                {" "}
                M
              </button>
            </div>

            <div className="">
              <button className="rounded-full w-8 hover:bg-white hover:text-black active:text-white active:bg-blue-200 bg-blue-200 text-lg font-bold text-white outline-1 mx-2">
                {" "}
                W
              </button>
            </div>
          </div>
        </div>
        <div class="w-full flex-1 shadow-md shadow-slate-400 bg-white sm:w-1/2 md:w-1/3 lg:w-1/5 xl:w-1/6 mb-4 mx-1 rounded-xl mr-6">
          <div className="text-center  mt-4">
            <div className="text-center">
              <button className=" text-center rounded-full w-12  bg-cyan-200 text-lg font-bold outline-1 mx-2">
                {" "}
                <svg
                className="relative top-1.5 left-1.5"
                width="46"
                height="46"
                viewBox="0 0 32 32"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M21 6L15.7071 11.2929C15.3166 11.6834 14.6834 11.6834 14.2929 11.2929L12.7071 9.70711C12.3166 9.31658 11.6834 9.31658 11.2929 9.70711L7 14"
                    stroke="#1F78B4"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M3 3V17.8C3 18.9201 3 19.4802 3.21799 19.908C3.40973 20.2843 3.71569 20.5903 4.09202 20.782C4.51984 21 5.07989 21 6.2 21H21"
                    stroke="#1F78B4"
                    stroke-linecap="round"
                  />
                </svg>
              </button>
            </div>
          </div>
          <h1 className="text-4xl text-center font-bold mt-4">99%</h1>
          <h1 className="text-lg text-center text-gray-500 mt-2 font-bold">
            Delievery Rate
          </h1>
          <p className="text-lime-400 text-center mb-1">
            <span>
              <span className="inline-block">
                <svg
                  width="14"
                  height="14"
                  viewBox="0 0 12 12"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M7 7L7.70711 6.29289L7 5.58579L6.29289 6.29289L7 7ZM11.2071 9.79289L7.70711 6.29289L6.29289 7.70711L9.79289 11.2071L11.2071 9.79289ZM6.29289 6.29289L2.79289 9.79289L4.20711 11.2071L7.70711 7.70711L6.29289 6.29289Z"
                    fill="#26F32E"
                  />
                  <path
                    d="M7 3.5L7.70711 2.79289L7 2.08579L6.29289 2.79289L7 3.5ZM11.2071 6.29289L7.70711 2.79289L6.29289 4.20711L9.79289 7.70711L11.2071 6.29289ZM6.29289 2.79289L2.79289 6.29289L4.20711 7.70711L7.70711 4.20711L6.29289 2.79289Z"
                    fill="#26F32E"
                  />
                </svg>
              </span>
            </span>
            <span className="ml-1 font-medium">0.8%</span>
          </p>
          <div className="text-center flex justify-center ml-auto mt-1 mb-4">
            <div className="">
              <button className="rounded-full w-8 text-blue-900 hover:bg-white hover:text-black active:text-white active:bg-blue-200 bg-cyan-200 text-lg font-bold outline-1 mx-2">
                {" "}
                Y
              </button>
            </div>
            <div className="">
              <button className="rounded-full w-8 text-blue-900 hover:bg-white hover:text-black active:text-white active:bg-blue-200 bg-cyan-200 text-lg font-bold outline-1 mx-2">
                {" "}
                M
              </button>
            </div>

            <div className="">
              <button className="rounded-full w-8 hover:bg-white hover:text-black active:text-white active:bg-blue-200 bg-blue-200 text-lg font-bold text-white outline-1 mx-2">
                {" "}
                W
              </button>
            </div>
          </div>
        </div>
      </div>
      <Suppliercharts />
      <Suppliermap/>
    </div>
  );
}
